module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "recommend__box"
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "recommend__item clearfix",
      class: {
        'recommend__item--left': index % 2 === 0, 'recommend__item--right': index % 2 !== 0
      }
    }, [_c('div', {
      staticClass: "recommend__identify"
    }, [_c('h3', [_c('img', {
      attrs: {
        "src": item.picPc,
        "alt": item.name
      }
    })]), _vm._v(" "), _c('h4', {
      staticClass: "title__en"
    }, [_vm._v("Professional real estate finance")]), _vm._v(" "), _c('h4', {
      staticClass: "title__ch"
    }, [_vm._v("专业的房产金融服务")])]), _vm._v(" "), _c('div', {
      staticClass: "recommend__introduce"
    }, [_c('h3', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "recommend__desc"
    }, [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('div', {
      staticClass: "recommend__explain"
    }, [_c('div', [_vm._v("借款额度：" + _vm._s(item.borrowMoney))]), _vm._v(" "), _c('div', {
      staticClass: "db-ib"
    }, [_vm._v("还款方式：" + _vm._s(item.repaymentType))]), _vm._v(" "), _c('div', {
      staticClass: "db-ib"
    }, [_vm._v("期限范围：" + _vm._s(item.duration))]), _vm._v(" "), _c('div', [_vm._v("费率说明：" + _vm._s(item.rateExplain))])]), _vm._v(" "), _c('div', {
      staticClass: "look__detail"
    }, [_c('a', {
      staticClass: "detail",
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          _vm.$router.push('/borrow/' + item.id)
        }
      }
    }, [_vm._v("[查看详情]")])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-da4e6276"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/list.vue
// module id = 626
// module chunks = 1